<template>
  <section>
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <div class="mt16">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item label="赛事">
          <el-select
            v-model="filters.MatchId"
            placeholder="请选择赛事"
            clearable
            filterable
            :loading="matchLoading"
            @change="onMatchChange"
          >
            <el-option
              v-for="item in matchOptions"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赛事项目">
          <el-select
            v-model="filters.MatchProductsId"
            placeholder="请选择赛事项目"
            clearable
            filterable
            :disabled="!filters.MatchId"
            :loading="matchProductLoading"
          >
            <el-option
              v-for="item in matchProductOptions"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="在宜宾意愿投资">
          <el-select
            v-model="filters.IsWillingToInvestInYibin"
            placeholder="请选择"
            clearable
          >
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="list" v-loading="listLoading" style="width: 100%">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column label="参赛姓名" prop="Name"></el-table-column>
      <el-table-column label="性别" prop="Gender"></el-table-column>
      <el-table-column label="身份证" prop="CardId"></el-table-column>
      <el-table-column label="手机号" prop="Phone"></el-table-column>
      <el-table-column label="赛事" prop="MatchName"></el-table-column>
      <el-table-column
        label="赛事项目"
        prop="MatchProductsName"
      ></el-table-column>
      <el-table-column label="出生日期" prop="BirthDay"></el-table-column>
      <el-table-column label="家庭地址" prop="FamilyAdress"></el-table-column>
      <el-table-column label="工作单位" prop="CompanyName"></el-table-column>
      <el-table-column label="在宜宾意愿投资">
        <template slot-scope="scope">
          {{
            scope.row.IsWillingToInvestInYibin === true
              ? "是"
              : scope.row.IsWillingToInvestInYibin === false
              ? "否"
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column label="报名缴费" prop="Payment"></el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
  </section>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  matchRegisterList,
  PostExportMatchRegisterExcel,
  matchList,
  productList,
} from "@/api/match/match";
import { downloadXls, dateNow } from "@/utils/util.js";
export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
      //新增界面数据
      addForm: {},
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {},
      filters: {
        key: "",
        MatchId: "",
        MatchProductsId: "",
        IsWillingToInvestInYibin: null,
      },
      matchOptions: [],
      matchProductOptions: [],
      matchLoading: false,
      matchProductLoading: false,
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.fetchMatches();
    this.getList();
  },
  methods: {
    async fetchMatches() {
      this.matchLoading = true;
      try {
        const res = await matchList({ page: 1, intPageSize: 999 });
        const response = res && res.data && res.data.response;
        if (Array.isArray(response)) {
          this.matchOptions = response;
        } else {
          this.matchOptions = (response && response.data) || [];
        }
      } catch (e) {
        this.matchOptions = [];
      } finally {
        this.matchLoading = false;
      }
    },
    async fetchMatchProducts(matchId) {
      if (!matchId) {
        this.matchProductOptions = [];
        return;
      }
      this.matchProductLoading = true;
      try {
        const res = await productList({
          page: 1,
          intPageSize: 999,
          MatchId: matchId,
          matchId: matchId,
        });
        const response = res && res.data && res.data.response;
        if (Array.isArray(response)) {
          this.matchProductOptions = response;
        } else {
          this.matchProductOptions = (response && response.data) || [];
        }
      } catch (e) {
        this.matchProductOptions = [];
      } finally {
        this.matchProductLoading = false;
      }
    },
    onMatchChange(matchId) {
      this.filters.MatchProductsId = "";
      this.matchProductOptions = [];
      this.fetchMatchProducts(matchId);
    },
    getList() {
      this.listLoading = true;
      let para = {
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize,
        key: this.filters.key,
      };
      if (this.filters.MatchId) {
        para.MatchId = this.filters.MatchId;
      }
      if (this.filters.MatchProductsId) {
        para.MatchProductsId = this.filters.MatchProductsId;
      }
      if (this.hasYibinInvestValue()) {
        para.IsWillingToInvestInYibin =
          this.filters.IsWillingToInvestInYibin;
      }
      matchRegisterList(para).then((res) => {
        this.listLoading = false;
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
      });
    },
    initPage() {
      this.page = {
        currentPage: 1,
        pageSize: 10,
      };
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    // 查询
    search() {
      this.getList();
    },
    // 导出
    exportXlsx() {
      // 构造查询参数, 不包含分页信息
      const params = {};
      if (this.filters.key) {
        params.Key = this.filters.key;
      }
      if (this.filters.MatchId) {
        params.MatchId = this.filters.MatchId;
      }
      if (this.filters.MatchProductsId) {
        params.MatchProductsId = this.filters.MatchProductsId;
      }
      if (this.hasYibinInvestValue()) {
        params.IsWillingToInvestInYibin =
          this.filters.IsWillingToInvestInYibin;
      }

      PostExportMatchRegisterExcel(params)
        .then((res) => {
          if (res && res.data) {
            downloadXls(res.data, `报名记录表${dateNow()}.xlsx`);
          } else {
            console.error("导出失败，未获取到数据");
          }
        })
        .catch((error) => {
          console.error("导出失败", error);
        });
    },
    callFunction(item) {
      this.filters.key = item.search;
      this[item.Func].apply(this, item);
    },
    hasYibinInvestValue() {
      return (
        this.filters.IsWillingToInvestInYibin === true ||
        this.filters.IsWillingToInvestInYibin === false
      );
    },
  },
};
</script>
